import type { Locale } from "../i18n";

const copy = {
	ja: {
		heroAlt: "Gaussian Splattingで再現されたギャラリー空間",
		heroCaption: "共有できる3D空間のイメージ",
		manage: "ログインしてリンクを管理",
		useCasesEyebrow: "利用例",
		useCasesTitle: "Gaussian Splattingデータを共有したいときに。",
		useCasesLead: "ファイルを直接渡したり、ビューアを準備したりせずに、リンクを送るだけで3Dデータを見てもらえます。",
		useCases: [
			{
				title: "制作中のデータを確認",
				body: "現場のスキャンや制作途中のモデルを、離れた相手にも3Dのまま確認してもらえます。",
			},
			{
				title: "作品をオンラインで紹介",
				body: "ポートフォリオや提案資料にリンクを掲載し、見る人が自由に視点を動かせる状態で作品を紹介できます。",
			},
			{
				title: "空間を3Dで記録",
				body: "展示や店舗などをスキャンしたデータを、あとからブラウザで確認できる形で保存できます。",
			},
		],
		recipientEyebrow: "共有リンクの閲覧",
		recipientTitle: "受け取る側は、リンクを開くだけ。",
		recipientBody:
			"専用アプリのインストールは不要です。受け取った人はブラウザ上で視点を動かし、見たい方向から3Dデータを確認できます。",
		recipientAlt: "点群として再現された日本の庭と建築空間",
		viewpointEyebrow: "表示する視点の設定",
		viewpointTitle: "最初に表示する位置と向きを設定できます。",
		viewpointBody:
			"プレビューで位置・向き・大きさを調整し、リンクを開いたときの視点として保存できます。最初に確認してほしい場所を設定してから共有できます。",
		viewpointAlt: "Gaussian Splattingで再現された建築模型",
		controls: [
			{ title: "公開期限", body: "1時間・1日・1週間・無期限から選べます。" },
			{ title: "パスワード", body: "必要に応じて、閲覧用のパスワードを設定できます。" },
			{ title: "リンク管理", body: "ログイン中に作ったリンクは、あとから編集・削除できます。" },
		],
		stepsEyebrow: "使い方",
		stepsTitle: "共有リンクを作成する手順",
		steps: [
			{
				number: "01",
				title: "ファイルを選ぶ",
				body: "SuperSplat 3.0などから書き出したPLY・SPZ・SOG、またはViewer AppのHTMLを選びます。",
			},
			{
				number: "02",
				title: "共有内容を設定する",
				body: "タイトルと公開期限を設定します。必要に応じて説明、パスワード、最初に表示する視点も追加できます。",
			},
			{
				number: "03",
				title: "リンクを送る",
				body: "アップロード後にできたリンクをコピーして、メールやチャットで送ります。",
			},
		],
		formatsEyebrow: "対応ファイル",
		formatsTitle: "対応形式",
		formatsIntro: "1ファイル最大2 GB。ログインせずに試せます。",
		formats: [
			{
				title: "PLY・SPZ・SOG",
				body: "GSplat Shareの3Dビューアで表示します。PLYとSOGはWebGPU対応環境でGPUソートを使い、使えない環境ではWebGL2で表示します。",
			},
			{
				title: "SuperSplat HTML",
				body: "SuperSplatの「Viewer App」から書き出したHTMLを共有できます。.ssprojは編集用のため、SuperSplatでPLY・SPZ・SOGかViewer Appへ書き出してください。",
			},
		],
		faqTitle: "よくある質問",
		faq: [
			{
				title: "料金はかかりますか？",
				body: "現在は無料ベータとして提供しています。ベータ期間中は、仕様や提供内容が変わる場合があります。",
			},
			{
				title: "ログインしなくても使えますか？",
				body: "使えます。あとからリンクを編集・削除したい場合は、アップロード前にGoogleでログインしてください。ログインせずに作ったリンクは、ご自身で保存してください。",
			},
			{
				title: "リンクは誰でも見られますか？",
				body: "リンクを知っている人が閲覧できます。パスワードを設定すると、閲覧時にパスワードの入力が必要になります。",
			},
			{
				title: "どの端末でも表示できますか？",
				body: "表示はブラウザや端末の描画性能、ファイル容量に左右されます。共有前にプレビューで見え方を確認できます。",
			},
		],
		ctaEyebrow: "GSplat Share",
		ctaTitle: "Gaussian Splattingデータを共有する",
		ctaBody: "対応ファイルを選択して、共有リンクを作成できます。",
		cta: "共有するファイルを選ぶ",
	},
	en: {
		heroAlt: "A gallery reconstructed with Gaussian Splatting",
		heroCaption: "Illustrative 3D spaces to share",
		manage: "Sign in to manage links",
		useCasesEyebrow: "Made for sharing",
		useCasesTitle: "Spend less time finding a sharing method. More time showing the 3D.",
		useCasesLead:
			"Your PLY or SPZ is ready. GSplat Share closes the gap between that file and the person who needs to see it.",
		useCases: [
			{
				title: "Review work in progress",
				body: "Send a spatial capture or unfinished model so people can review it in 3D from wherever they are.",
			},
			{
				title: "Present your work",
				body: "Add a link to your portfolio or proposal and show depth that still images cannot convey.",
			},
			{
				title: "Keep a record of a place",
				body: "Save exhibitions, stores, and memorable places as 3D data you can open again later.",
			},
		],
		recipientEyebrow: "For the people you share with",
		recipientTitle: "Open the link. Explore in 3D.",
		recipientBody:
			"No dedicated app is required. Recipients can move around the capture and inspect it from any angle in their browser.",
		recipientAlt: "A Japanese garden and building reconstructed as a point-based scene",
		viewpointEyebrow: "Set the presentation",
		viewpointTitle: "Start from the view that matters.",
		viewpointBody:
			"Adjust position, angle, and scale in the preview, then save that as the opening view. Take people straight to the detail you want them to see.",
		viewpointAlt: "An architectural model reconstructed with Gaussian Splatting",
		controls: [
			{ title: "Expiration", body: "One hour, one day, one week, or no expiration" },
			{ title: "Password", body: "Limit access when you need to" },
			{ title: "Manage links", body: "Edit or delete links created while signed in" },
		],
		stepsEyebrow: "How it works",
		stepsTitle: "From a file to a shareable link in three steps.",
		steps: [
			{
				number: "01",
				title: "Choose a file",
				body: "Select PLY, SPZ, SOG, or Viewer App HTML exported from SuperSplat 3.0 or another editor.",
			},
			{
				number: "02",
				title: "Set the presentation",
				body: "Add a title and expiration, plus an optional description, password, and opening view.",
			},
			{ number: "03", title: "Send the link", body: "Copy the link after upload and send it by email or chat." },
		],
		formatsEyebrow: "File formats",
		formatsTitle: "Supported formats",
		formatsIntro: "Up to 2 GB per file. No sign-in required to try it.",
		formats: [
			{
				title: "PLY · SPZ · SOG",
				body: "Displayed in the GSplat Share 3D viewer. PLY and SOG use GPU sorting on WebGPU devices and WebGL2 elsewhere.",
			},
			{
				title: "SuperSplat HTML",
				body: "Share Viewer App HTML. For .ssproj editing projects, export PLY, SPZ, SOG, or Viewer App HTML from SuperSplat first.",
			},
		],
		faqTitle: "Frequently asked questions",
		faq: [
			{
				title: "How much does it cost?",
				body: "GSplat Share is currently available as a free beta. Features and availability may change during the beta.",
			},
			{
				title: "Can I use it without signing in?",
				body: "Yes. Sign in with Google before uploading if you want to edit or delete the link later. Save links you create while signed out.",
			},
			{
				title: "Who can open a link?",
				body: "Anyone with the link can view it. If you set a password, recipients need it to open the capture.",
			},
			{
				title: "Does it work on every device?",
				body: "Viewing depends on browser support, device graphics capabilities, and file size. Check the preview before sharing.",
			},
		],
		ctaEyebrow: "GSplat Share",
		ctaTitle: "Turn your 3D data into a link.",
		ctaBody: "Choose a file, set the presentation, and share it.",
		cta: "Choose a 3D file",
	},
} as const;

export function getLandingCopy(locale: Locale) {
	return copy[locale];
}
